import type { AppThunkDispatch, RootState } from '../..';
import { selectTreeDataByCatalogId } from '../../selectors/tree/tree';
import { updateCategoryStatusFromTreeData } from '../../slices/indicator';

export const updateCategoryStatusByCatalogId =
  (catalogId: string) =>
  async (dispatch: AppThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const treeData = selectTreeDataByCatalogId(state, catalogId);

    return dispatch(updateCategoryStatusFromTreeData(treeData, catalogId));
  };
